import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const NoResults: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([0, 18, 182, 18]),

    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },

    [theme.screen.laptop]: {
        ':first-child': {
            margin: pxArrayToRem([100, 0]),
        },

        [`& .${captionClassName}`]: {
            fontSize: pxToRem(30),
            lineHeight: 1.3,
        },
        margin: pxArrayToRem([100, 0]),
    },
});
